<div class="container">



    <h1 class="text-center mt-5" style="color: #f8ad33;font-weight: 1000 !important;">POLITIQUE DE CONFIDENTIALITÉ</h1>


    <h1 class="text-left" style="color: #a2b73d;"><b>Vos données personnelles vous appartiennent</b></h1>

    <p> En France, chaque personne dispose d’un droit d’accès, de modification, de rectification et de suppression de
        ses données personnelles. Ces droits sont inscrits dans la loi depuis 1978.
    </p>
    <p>Les données personnelles sont des données relatives à une personne physique identifiée ou identifiable. Selon le
        règlement général sur la protection des données, « une personne physique identifiable est une personne qui peut
        être identifiée, directement ou indirectement, en faisant référence à un identifiant ». Il peut s'agir d'un nom,
        d’une adresse, d’un numéro de téléphone, d’informations bancaires, etc.
    </p>
    <p>
        Dans ce contexte, les traitements de données personnelles effectués par Clem' ont fait précédemment l’objet de
        déclarations auprès de la CNIL (Commission Nationale de l’Informatique et des Libertés) sous les numéros
        de récépissés 1450253, 1905554 et 2098337.
    </p>
    <p> Le Règlement général pour la protection des données (RGPD) (en anglais, GDPR : General data protection
        regulation), en application à l’échelle européenne depuis mai 2018, confirme, renforce et précise ces droits.
    </p>




    <h1 class="text-left" style="color: #a2b73d;"><b>Le RGPD, qu’est-ce que c’est ?</b></h1>

    <p>Le Règlement général pour la protection des données (RGPD) est le nouveau texte de référence européen
        en matière de protection de vos données personnelles.</p>
    <p>Objectif du RGPD : renforcer les droits des citoyens en leur donnant plus de contrôle sur leurs données privées,
        car elles leur appartiennent !</p>
    <p>Ce règlement harmonise la gestion des données dans l’ensemble des pays de l’Union Européenne. Il concerne les
        entreprises, les associations, les organismes publics qui y ont leur siège et leurs sous-traitants.
        Les structures situées hors de l’UE sont aussi impliquées dès lors qu’elles traitent des données de citoyens
        européens.</p>




    <h1 class="text-left" style="color: #a2b73d;margin-top: 1.5em;"><b>Quels sont vos droits sur vos données ?</b>
    </h1>

    <p>
        La loi définit avec précision quels sont vos droits sur vos données.
    </p>
    <p>
        Droit de propriétéVos données personnelles doivent le rester car elles vous appartiennent !
        Nous nous engageons à ne pas communiquer vos données personnelles à des tiers, sauf exceptionnellement et dans
        ce cas avec votre consentement explicite préalable.
    </p>
    <p>
        Droit à la sécuritéToutes les données personnelles que vous nous confiez sont enregistrées dans des bases de
        données dont l’accès est contrôlé et sécurisé. Vos données sont traitées et conservées dans nos centres de
        données sur le territoire français, ou, exceptionnellement de l’Union Européenne. Dans tous les cas elles
        bénéficient donc totalement de la protection juridique du RGPD, et notamment de l’interdiction de la sortie
        de vos données hors de l’Union Européenne sans votre contentement explicite préalable
    </p>
    <p>Droits d’accès et de rectification: à tout moment, vous pouvez demander l’accès à vos données personnelles
        et la rectification de celles-ci. Plusieurs solutions s’offrent à vous pour rectifier vos données si celles-ci
        ne sont plus à jour. Vous pouvez les modifier directement dans votre espace personnel, ou en nous contactant
        comme indiqué ci-dessous. (Notez que dans ce cas, il pourra vous être demandé des informations complémentaires
        pour justifier de votre identité et pour ainsi faire valoir la légitimité de votre demande.)
    </p>
    <p>Droit de portabilité: vous pouvez demander la communication des données qui vous concernent dans un format
        informatique ou nous demander de les adresser à une autre personne. Ce droit ne s'applique qu'aux données
        qui vous concernent et que vous nous avez fournies dans le cadre de vos contrats ou avec votre consentement.
    </p>
    <p>Droit d’opposition: dans certains cas, vous pouvez vous opposer au traitement de vos données personnelles
        en fonction de votre situation particulière, mais cela pourra entraîner la résiliation du contrat de ceux des
        services pour lesquels ces données sont nécessaires.
    </p>
    <p>Droit à l’effacement et à l’oubli : lorsque vos données ne sont pas indispensables pour un contrat ou un service
        vous pouvez demander leur effacement. Nous nous efforçons de limiter automatiquement la conservation de vos
        données en fonction des finalités et des durées de prescription applicables. Si vous cessez d’utiliser nos
        services, vous pouvez nous demander à tout instant la suppression de vos données nécessaires à ces services,
        dans le respect de nos obligations de conservation notamment pour assurer la bonne fin du contrat.
    </p>
    <p>Droit de retirer votre consentement : pour tous les traitements pour lesquels votre consentement explicite
        a été recueilli, vous avez le droit de retirer ce consentement sans que cela n’entraîne de conséquences
        négatives pour vous, autres que la fin des services pour lesquels cette information est nécessaire.
    </p>
    <p>Droit de définir le sort de vos données post mortem: vous pouvez définir des directives relatives à la
        conservation, à l'effacement et à la communication de vos données après votre décès.
    </p>


    <h1 class="text-left" style="color: #a2b73d;margin-top: 1.5em;"><b>Les données personnelles recueillies par
            Clem'</b></h1>


    <p>
        Le présent texte vous explique quelles sont les données personnelles que Clem' utilise pour vous assurer les
        services que vous avez souscrits. Nous collectons uniquement les informations dont nous avons besoin pour
        assurer nos services
    </p>
    <p>
        Ces données peuvent soit vous être demandées à l’inscription (et dans ce cas le caractère obligatoire ou non des
        données est mentionné dans les formulaires d’inscription) soit ces données sont générées par l’utilisation de
        nos services et recueillies par nos systèmes.
    </p>
    <p>
        Nous ne vendons (ni ne donnons !) jamais vos données !
    </p>
    <p>
        Il peut s’agir de données très variées mais qui sont toujours associées à une personne physique et que donc nous
        vous demandons à l’inscription : nom, identité, numéro de téléphone, coordonnées bancaires pour tous nos
        services (autopartage, recharge de véhicule électrique ou covoiturage-passager).
    </p>
    <p>De plus, si vous utilisez nos services d’autopartage de véhicules ou de covoiturage-conducteur, nous vous
        demandons également des informations complémentaires telles que celles liées à votre permis de conduire.
    </p>
    <p>
        Vos données personnelles sont destinées à Clem' et à ses éventuels sous-traitants, partenaires ou prestataires
        dans le cadre de la réalisation des services pour lesquels vos données sont conservées. Elles ne sont donc
        jamais communiquées à des tiers sans liaison avec l’exécution des contrats qui nous lient.
    </p>
    <p>
        En fonction des services que vous utilisez, nous pouvons donc être amenés à collecter plusieurs catégories
        d’informations, plus précisément :
    </p>
    <p>
        Les informations d'identification et de contact. Vous nous fournissez ces informations. Il s’agit des données
        relatives à votre identité telles que vos nom, prénoms, sexe, date de naissance, adresse postale, adresse de
        courriel, numéro de téléphone que vous utilisez pour accéder à nos services ou appeler le service d’assistance,
        etc.
    </p>
    <p>
        Des données bancaires comme par exemple des numéros de chèque, des références bancaires (RIB, IBAN, BIC, relevé
        postal, mandat SEPA) ou encore des numéros de cartes de crédit (dans ce dernier cas, notez que c’est l’organisme
        bancaire seul qui dispose du numéro complet, auquel nous n’avons jamais accès). Vous nous fournissez ces
        informations.
    </p>
    <p>
        Les informations de facturation des services ou assimilés. Vos utilisations génèrent ces données que nous
        recueillons et conservons selon la politique de conservation définie. Dans le cadre du service d’autopartage
        de véhicules, nous recueillons également le relevé détaillé des points GPS parcourus par les véhicules
        (et donc par leurs conducteurs). Ces informations sont utilisées sous forme synthétique pour la facturation,
        mais leur détail est parfois nécessaire pour éclaircissement et lors de fraudes. Nous conservons ces données
        un trimestre, date à laquelle elles ne sont plus disponibles en ligne mais archivées dans le respect de nos
        obligations de conservation.
    </p>
    <p>
        Les données relatives à nos échanges et interactions d’assistance, c’est-à-dire les informations que nous
        échangeons lors de nos correspondances : SMS et courriers électroniques d’assistance ou de suivi d’incident.
    </p>
    <p>
        Pour permettre l’exécution des prestations et contrats
    </p>
    <p>
        Nous utilisons vos données personnelles pour l’inscription et l’exécution des contrats qui nous lient.
        Dans ce cadre, nous utilisons vos données pour :
    </p>
    <ul>
        <li>La passation et la gestion administrative des contrats et services, et notamment la confirmation
            électronique de vos contrats et les paiements ; </li>
        <li>L’exercice des recours, la gestion des réclamations et des contentieux ;</li>
        <li>Vous fournir un compte personnel sur internet en fonction des produits ou services que vous utilisez, ou
            pour assurer votre identification lorsque vous nous contactez ou que vous vous connectez à nos services
            en ligne ou sur nos applications mobiles ;</li>
        <li>L’élaboration des statistiques et études.</li>
    </ul>


    <h1 class="text-left" style="color: #a2b73d;margin-top: 1.5em;"><b>Pour la réalisation de nos intérêts légitimes</b>
    </h1>
    <p class="mb-2">
        Nous traitons certaines de vos données personnelles pour nous permettre de réaliser nos intérêts légitimes,
        c’est-à-dire apporter une réponse à l’un de nos besoins, dans le respect d’un équilibre avec vos propres droits
        et libertés.
    </p>
    <p>
        Nous poursuivons plusieurs intérêts et utilisons vos données pour :
    </p>
    <ul>
        <li>Élaborer des statistiques du fonctionnement et de l’utilisation de nos services, sites internet et
            applications mobiles ;</li>
        <li>Vérifier le bon fonctionnement de nos services, de nos applications mobiles, de nos sites internet et en
            améliorer la sécurité, en déceler et corriger éviter les problèmes ou dysfonctionnements ;</li>
        <li>Assurer la sécurité et la protection de l’ensemble des données vous concernant, déceler les activités
            anormales ou illégales ;</li>
        <li>Détecter des cas de fraude et enquêter pour préserver nos intérêts mutuels.</li>
    </ul>

    <p>Nous utilisons l’outil d’analyse d’audience et de suivi Matomo. Seuls les cookies essentiels au fonctionnement du
        site sont déposés. </p>

    <iframe style="border: 0; height: 200px; width: 600px;"
        src="https://clem.matomo.cloud/index.php?module=CoreAdminHome&action=optOut&language=fr&fontColor=7b7c7b&fontFamily=Lucida"></iframe>




    <h1 class="text-left" style="color: #a2b73d;margin-top: 1.5em;"><b>Durée de conservation de vos données
            personnelles</b></h1>
    <p class="mb-2">
        La durée de conservation de vos données personnelles varie en fonction des finalités pour lesquelles vos données
        sont traitées et des contrats ou services que vous utilisez. Elle peut également résulter d’obligations légales
        de conservation.
    </p>
    <p>
        Pour nos contrats de services, la durée est liée à celle de votre contrat, et prend fin six mois après la
        résiliation de celui-ci, pour en garantir la bonne fin.
    </p>



    <h1 class="text-left" style="color: #a2b73d;margin-top: 1.5em;"><b>Vos contacts avec Clem’</b></h1>
    <p class="mb-2">
        Clem' a désigné un délégué à la protection des données personnelles.
    </p>
    <p>
        Vous pouvez le contacter
    </p>
    <ul>
        <li>Par courrier postal en écrivant à :



            Délégué à la protection des données,

            . 9 villa des Sablons

            92200 NEUILLY SUR SEINE</li>
        <li>Par courrier électronique en écrivant à l’adresse de courriel : protection-donnees@clem-e.com</li>

    </ul>

    <p style="margin-bottom: 3em;">Pour plus d’information, consultez notre section Mentions légales / gestion des
        cookies.</p>


</div>